import { memo, useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import type { ChangeEvent } from "react";

export type Size = "small" | "medium";
type Props = {
	color: string;
	readonly?: boolean;

	size: Size;
	onChangeColor: (value: string) => void;
};

export const ColorPicker = memo(({ color, size, readonly, onChangeColor }: Props) => {
	const handleChangeColor = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			onChangeColor(value);
		},
		[onChangeColor],
	);

	return (
		<div
			className={cn(
				"shrink-0 rounded-full border border-zinc-400",
				size === "small" ? "h-[36px] w-[36px]" : "h-[54px] w-[54px]",
			)}
			style={{ background: color }}
		>
			<input
				className="h-full w-full opacity-0"
				type="color"
				value={color}
				readOnly={readonly}
				onChange={handleChangeColor}
			/>
		</div>
	);
});
